import LiveCheckinPublicPage from "./LiveCheckinPublicPage";

export default LiveCheckinPublicPage